// Panel dédié OpenClaw — pattern network (1 fichier fin par CLI).
import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { CliPanel } from "./cli/cli-panel";

const OpenClawCliPanel: Component = () => <CliPanel cli="openclaw" />;

registerPanel("cli-openclaw", OpenClawCliPanel);
export default OpenClawCliPanel;
